<template>
  <div :class="{box: true, closeAnimation}">

    <div class="title-nav">
      <div class="title">Reset password</div>
      <div class="close">
        <font-awesome-icon icon="times" class="icon" @click="close"/>
      </div>
    </div>

    <div class="info-box">
      <div class="frame">
        Enter your email and we'll send you a link to reset your password.
      </div>
    </div>

    <div class="input-box">
      <div class="frame">
        <div class="name" :class="{ name_error: emailError }"><span class="label">Your Email</span><span class="error">{{ emailError }}</span></div>
        <div class="input">
          <input type="text" v-model="email" :class="{ input_error: emailError }" @input="emailError = ''">
        </div>
      </div>
    </div>

    <div class="button-box">
      <div class="frame">
        <button @click="buttonClick">Reset Password</button>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import axios from 'axios';
import alert from '@/lib/alert';

export default {
  name: 'ResetPasswordBox',
  props: {
    copiedEmail: String
  },
  data() {
    return {
      loading: false,
      closeAnimation: false,
      email: '',
      emailError: null
    }
  },
  methods: {
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 200);
    },
    buttonClick() {
      this.createResetLink();
    },
    createResetLink() {
      this.loading = true;
      axios.post(`${process.env.VUE_APP_SERVER_URL}createResetLink`, {
        email: this.email
      })
      .then(() => {
        this.loading = false;
        this.$emit('close');
        alert.showSuccess('Reset link sent', 2000);
      })
      .catch(response => {
        this.loading = false;
        if(response.response.data.error == 'not found') {
          this.emailError = "not found";
        } else {
          alert.showError('Link sending error', 2000);
        }
      });
    }
  },
  mounted() {
    if(this.copiedEmail != '') {
      this.email = this.copiedEmail;
    }
  }
}
</script>

<style lang="scss" scoped>
  .box {
    position: fixed;
    z-index: 100;
    top: calc(50vh - 12.5rem);
    left: calc(50vw - 12.5rem);
    width: 25rem;
    height: auto;
    background-color: whitesmoke;
    border-radius: 0.3rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: start 0.2s forwards ease;
    filter:drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.212));
    padding-bottom: 1.5rem;

    @media (max-width: 600px) {
      position: absolute;
      top: 6rem;
      width: 90vw;
      left: calc(50vw - 45vw);
    }
  }

  .closeAnimation {
    animation: close 0.2s forwards ease;
  }

  .title-nav {
    width: 100%;
    height: 4rem;
    display: flex;
    flex-direction: row;
    background-color: #11b6a5;

    .title {
      width: auto;
      height: auto;
      display: flex;
      align-items: center;
      color: white;
      font-size: 1.5rem;
      padding-left: 2rem;
    }

    .close {
      width: 4rem;
      height: 4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      color: white;
      font-size: 1.2rem;

      .icon {
        transition: 0.2s;

        &:hover {
          opacity: 0.8;
          cursor: pointer;
        }
      }
    }
  }

  .info-box {
    margin-top: 1.5rem;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      color: rgb(119, 119, 119);
      line-height: 1.8rem;
      font-size: 1rem;
      font-weight: bold;
    }
  }

  .input-box {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.5rem;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    
    .name {
      width: 100%;
      height: 2rem;
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: rgb(172, 169, 169);

      .label {
        font-weight: bold;
      }

      .error {
        margin-left: 0.5rem;
        font-style: italic;
      }
    }

    .name_error {
      color: rgb(239, 70, 70);
    }

    .input_error {
      border-color: rgb(239, 70, 70) !important;
    }

    .input {
      width: 100%;
      flex: auto;
      display: flex;

      input {
        width: 100%;
        height: 2rem;
        background: none;
        border: none;
        outline: none;
        background-color: rgb(226, 225, 225);
        font-size: 1rem;
        color: rgb(37, 38, 41);
        transition: 0.2s;
        border: 1px rgb(202, 201, 201) solid;
        border-radius: 0.1rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        @media (max-width: 600px) {
          height: 2.5rem;
        }
      }

      input:focus {
        border-color: #11b6a5;
      }
    }
  }

  .button-box {
    width: 100%;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    button {
      width: 100%;
      height: 2.5rem;
      background: none;
      border: none;
      outline: none;
      background-color: #11b6a5;
      color: white;
      font-weight: bold;
      font-size: 0.95rem;
      border-radius: 0.1rem;
      transition: 0.2s;

      &:hover {
        cursor: pointer;
        background-color: #10a394;
      }
    }
  }


//Loading Animation
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 1rem;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}


//Box Start Animation

@keyframes start {
  0% {
    transform: translateY(5rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
}

@keyframes close {
  0% {
    transform: translateY(0rem);
    opacity: 1;
  }
  100% {
    transform: translateY(-5rem);
    opacity: 0;
  }
}
</style>